import { type Modification } from '../../types';

/**
 * Sorts modifications by their order.
 */
export function sortModifications(modifications: Modification[]) {
  const sortedByGroupOrder = [...modifications].sort(sortByModificationGroupOrder); // prettier-ignore
  const sortedByOrder = [...sortedByGroupOrder].sort(sortByModificationOrder);

  return sortedByOrder;
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function sortByModificationGroupOrder(
  currentModification: Modification,
  nextModification: Modification,
) {
  return currentModification.modificationGroupOrder - nextModification.modificationGroupOrder; // prettier-ignore
}

function sortByModificationOrder(
  currentModification: Modification,
  nextModification: Modification,
) {
  return currentModification.order - nextModification.order;
}
